export default {
  path: "/:type/wecode-v2",
  auth: true,
  preload: false,
  key: "wecode",
  layout: "inner", // outer 一级菜单 inner 二级菜单
  component: () => import(/* webpackChunkName: "wecode" */ "./index")
};
